import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CRMTinhThanhClient, CRM_TinhThanhDto } from '../../api-connector/sso-connector';
import { TinhThanhService } from '../../services/tinh-thanh.service';
import { BaseAutocompleteControl } from '../base-autocomplete-control';

@Component({
  selector: 'tinh-thanh-control',
  templateUrl: './tinh-thanh-control.component.html',
  styleUrls: ['./tinh-thanh-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TinhThanhControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TinhThanhControlComponent),
      multi: true,
    }
  ]
})
export class TinhThanhControlComponent extends BaseAutocompleteControl<CRM_TinhThanhDto> implements OnInit {

  @Input() maTinhThanh?: string;
  @Input() showOld?: string;

  // Cache to prevent duplicate API calls
  private loadedCode: string | null = null;

  constructor(
    private service: TinhThanhService,
    private tinhThanhClient: CRMTinhThanhClient
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Fetch provinces with client-side filtering from service
   */
  protected fetchItems(searchValue: string): Observable<CRM_TinhThanhDto[]> {
    return this.service.getAll().pipe(
      map(() => this.service.filterCRMWithTag(searchValue))
    );
  }

  /**
   * Override writeValue to handle code-based loading
   */
  writeValue(code: string | CRM_TinhThanhDto): void {
    if (!code) {
      this.control.setValue(null, { emitEvent: false });
      this.selectedItem = null;
      this.loadedCode = null;
      return;
    }

    // If already a DTO object, use it directly
    if (code instanceof CRM_TinhThanhDto) {
      this.control.setValue(code, { emitEvent: false });
      this.selectedItem = code;
      this.loadedCode = code.maTinhThanh || null;
      return;
    }

    // If code is a string and not already loaded or different from current
    if (typeof code === 'string' && code !== this.loadedCode) {
      this.loadedCode = code || null;

      // Try to get from service cache first
      const cached = this.service.findByCode(code);
      if (cached) {
        this.control.setValue(cached, { emitEvent: false });
        this.selectedItem = cached;
      } else {
        // Fallback to API call if not in cache
        this.tinhThanhClient.getDetail(code).subscribe(
          result => {
            this.control.setValue(result, { emitEvent: false });
            this.selectedItem = result;
          },
          error => {
            console.error('Error loading province:', error);
            this.control.setValue(null, { emitEvent: false });
            this.selectedItem = null;
          }
        );
      }
    }
  }

  getDisplayValue(item: CRM_TinhThanhDto | null): string {
    return item?.tenTinhThanh || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof CRM_TinhThanhDto;
  }
}
